const config = {
	backendLocation: "https://api.ieeetechithon.com",
	razorpayKey: "rzp_live_ke9vhgAgsP0n62",
	// razorpayKey: "rzp_test_qExSitmCBrejZo",
};

export default config;
